import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

@Directive({
  selector: '[cslMaxNumberPrecision]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MaxNumberPrecisionDirective, multi: true }],
})
export class MaxNumberPrecisionDirective implements Validator {
  @Input('cslMaxNumberPrecision') maxNumberPrecision = 100;

  validate(control: AbstractControl): ValidationErrors | null {
    return maxNumberPrecision(this.maxNumberPrecision)(control);
  }
}

/**
 * @param maxPrecision
 */
export function maxNumberPrecision(maxPrecision: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = +control.value;

    const forbidden = Math.floor(value) === value ? false : (value.toString().split('.')[1].length || 0) > maxPrecision;
    return forbidden ? { maxNumberPrecision: { value: control.value, max: maxPrecision } } : null;
  };
}
